export default __webpack_public_path__ + "static/media/Draw-QuickDraw-Logo.6018c61a.svg";